// @ts-expect-error untyped import
import { combineActions, handleActions } from 'flux-actions';
// @ts-expect-error untyped import
import * as ActionTypes from '../actions/ActionTypes';
const initialState = null;
export default handleActions({
  [ActionTypes.SET_FORM_STATE](state, action) {
    return action.payload;
  },
  [combineActions(ActionTypes.RESET_FORM_STATE, ActionTypes.BOOKING_TIME_CONFLICT)]() {
    return initialState;
  }
}, initialState);